"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypedText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useInterval_1 = require("../../hooks/useInterval");
function TypedText({ children: text, onDone, duration, }) {
    const [lengthToShow, setLengthToShow] = react_1.useState(0);
    const interval = duration === undefined ? 50 : duration / text.length;
    useInterval_1.useInterval(() => {
        setTimeout(() => {
            if (lengthToShow <= text.length) {
                setLengthToShow(old => {
                    if (old <= text.length) {
                        return old + 1;
                    }
                    else {
                        return old;
                    }
                });
            }
        }, Math.random() * interval);
    }, interval);
    const printingText = react_1.useRef(text);
    const onDoneCalled = react_1.useRef(false);
    react_1.useEffect(() => {
        if (printingText.current !== text) {
            printingText.current = text;
            onDoneCalled.current = false;
            setLengthToShow(0);
        }
    }, [setLengthToShow, text]);
    react_1.useEffect(() => {
        if (onDone && text.length === lengthToShow && !onDoneCalled.current) {
            onDone();
            onDoneCalled.current = true;
        }
    }, [onDone, text, lengthToShow]);
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [text.substring(0, lengthToShow), lengthToShow < text.length ? '|' : ''] }, void 0));
}
exports.TypedText = TypedText;
//# sourceMappingURL=index.js.map